import typo from '../../../atoms/flightBriefPdf/flightBriefTypography.module.css';
import styles from './BriefFooter.module.css';

/**
 * Dark footer band: legal mention on the left, vertical rule and the document
 * generation date on the right.
 * @param {object} props
 * @param {React.ReactNode} props.legal - Legal mention text.
 * @param {React.ReactNode} props.generatedLabel - "Document generated" caption.
 * @param {React.ReactNode} props.generatedAt - Formatted generation date.
 * @param {string} [props.className] - Extra class names for layout overrides.
 * @returns {JSX.Element}
 */
function BriefFooter({
  legal,
  generatedLabel,
  generatedAt,
  className = '',
}) {
  return (
    <footer className={`${styles.footer} ${className}`}>
      <div className={styles.row}>
        <p className={`${styles.legal} ${typo['p3-light']}`}>{legal}</p>
        <span className={styles.rule} />
        <div className={styles.generated}>
          <span className={`${styles.caption} ${typo['p3-light']}`}>{generatedLabel}</span>
          <span className={`${styles.date} ${typo['p3-light']}`}>{generatedAt}</span>
        </div>
      </div>
    </footer>
  );
}

export default BriefFooter;
